import {SiteDomain} from '@domain/model/Site/Site';
import {Locale} from '@domain/model/Site/Locale';

import {COUNTRY, LANGUAGE} from './Site.definition';
import {getStore} from './getStore';

const getCompositeLocale = (): string => {
  const {country, language} = getLocale();

  return `${language}-${country}`;
};

const getLocale = (): Locale => {
  const site: SiteDomain = getStore();

  return {language: LANGUAGE[site], country: COUNTRY[site]};
};

export {getLocale, getCompositeLocale, LANGUAGE, COUNTRY};
